import { useState } from "react";
import { useTheme } from "../contexts/ThemeContext";
import { setMultimonedaFlag } from "../hooks/useMultimoneda";
import { setTenantTipo } from "../hooks/useTenantTipo";
import { getProfile } from "../../features/auth/services/authService";
import { guardarPermisos, claveDeRuta, puede, inicioDelRol } from "../utils/permisos";

export default function CondominioSelector() {
  const { theme } = useTheme();
  const isLight   = theme === "light";

  // CONTADOR, AGUA y el USUARIO con varios condominios usan
  // "condominios_contador"; el superadmin usa "condominios_admin" (acceso a
  // todos los condominios). Todos comparten "active_condominio_id".
  const condominios = JSON.parse(
    localStorage.getItem("condominios_contador") ||
    localStorage.getItem("condominios_admin") ||
    "[]"
  );
  const activeId    = localStorage.getItem("active_condominio_id") || "";
  const [selected, setSelected] = useState(activeId);

  if (condominios.length === 0) return null;

  async function handleChange(e) {
    const newId  = e.target.value;
    setSelected(newId);
    localStorage.setItem("active_condominio_id", newId);
    // Sincronizar el flag de multimoneda del condominio recién seleccionado
    const condo = condominios.find(c => String(c.id) === newId);
    setMultimonedaFlag(!!condo?.multimoneda_activa);
    setTenantTipo(condo?.tipo || "condominio");
    // Los permisos pueden ser otros en este condominio: cargarlos antes de
    // recargar y, si la pantalla actual no está permitida acá, ir al inicio.
    try {
      const perfil = await getProfile();
      const permisos = perfil?.usuario_condominio?.permisos;
      if (Array.isArray(permisos)) guardarPermisos(permisos);
    } catch { /* Layout los vuelve a pedir al recargar */ }
    const clave = claveDeRuta(window.location.pathname, window.location.search);
    if (clave && !puede(clave)) {
      const rol = localStorage.getItem("rol");
      window.location.href = inicioDelRol(rol) || "/";
      return;
    }
    window.location.reload();
  }

  return (
    <>
      <style>{`
        .condo-selector {
          background: ${isLight ? "rgba(var(--brand-rgb), 0.06)" : "rgba(var(--brand-rgb), 0.08)"};
          border: 1px solid rgba(var(--brand-rgb), 0.35);
          border-radius: 8px;
          color: var(--brand);
          padding: 5px 10px;
          font-size: 0.82rem;
          font-weight: 700;
          outline: none;
          cursor: pointer;
          max-width: 200px;
          min-width: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        @media (max-width: 600px) {
          .condo-selector {
            max-width: 120px;
            font-size: 0.72rem;
            padding: 4px 8px;
          }
        }
      `}</style>
      <select
        className="condo-selector"
        value={selected}
        onChange={handleChange}
        title="Condominio activo"
      >
        {condominios.map(c => (
          <option key={c.id} value={String(c.id)}>{c.nombre}</option>
        ))}
      </select>
    </>
  );
}
